import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-6" }
const _hoisted_2 = { class: "_grid _grid-cols-1 _grid-cols-2--m _grid-cols-3--l _gap-6" }
const _hoisted_3 = { class: "_px-3" }
const _hoisted_4 = { class: "gfu-hd gfu-hd--h4" }
const _hoisted_5 = { class: "_flex _jc-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_performance_marketing_section = _resolveComponent("performance-marketing-section")

  return (_openBlock(), _createBlock(_component_performance_marketing_section, { title: "Why Adfound?" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.benefits, (benefit) => {
            return (_openBlock(), _createElementBlock("div", {
              key: benefit.title,
              class: "_flexcol _gap-2 _tac"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_base_icon, {
                  name: benefit.icon,
                  size: "3x",
                  class: "_tc--accent"
                }, null, 8 /* PROPS */, ["name"])
              ]),
              _createElementVNode("h5", _hoisted_4, _toDisplayString(benefit.title), 1 /* TEXT */),
              _createElementVNode("div", null, _toDisplayString(benefit.description), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_base_button, {
            theme: "accent",
            onClick: $options.onTryForFree
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Try Adfound ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}